import dayjs from "dayjs";

const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

export const unwrapUserPayload = (payload = {}) => {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return payload || {};
  }
  if (payload.id || payload.userId || payload.username || payload.firstname) {
    return payload;
  }
  if (payload.data && typeof payload.data === "object" && !Array.isArray(payload.data)) {
    return unwrapUserPayload(payload.data);
  }
  if (payload.user && typeof payload.user === "object") {
    return unwrapUserPayload(payload.user);
  }
  return payload;
};

export const normalizeUser = (rawInput = {}) => {
  const raw = unwrapUserPayload(rawInput);
  const userId = firstDefined(raw.userId, raw.id, raw._id, "");
  const username = firstDefined(raw.username, raw.userName, "");
  const firstname = firstDefined(raw.firstname, raw.firstName, raw.name, "");
  const lastname = firstDefined(raw.lastname, raw.lastName, "");
  const roles = Array.isArray(raw.roles) ? raw.roles : [];

  return {
    ...raw,
    id: userId,
    userId,
    username: username || firstDefined(raw.name, firstname, ""),
    firstname,
    lastname,
    email: firstDefined(raw.email, ""),
    mobile: firstDefined(raw.mobile, ""),
    roles,
    enabled: Boolean(raw.enabled),
    locked: Boolean(raw.locked),
    mfaEnabled: Boolean(raw.mfaEnabled),
    creationDate: firstDefined(raw.createdAt, raw.creationDate, raw.createdDate),
    lastModifiedDate: firstDefined(
      raw.lastModifiedDate,
      raw.updatedAt,
      raw.lastModified
    ),
    lastLoggedInTs: firstDefined(raw.lastLoggedInTs, raw.lastLogin, raw.lastLoggedIn),
    type: firstDefined(raw.type, raw.userType, ""),
  };
};

export const normalizeUserList = (payload) => {
  if (Array.isArray(payload)) {
    return payload.map(normalizeUser);
  }

  if (Array.isArray(payload?.content)) {
    return payload.content.map(normalizeUser);
  }

  if (Array.isArray(payload?.data)) {
    return payload.data.map(normalizeUser);
  }

  if (Array.isArray(payload?.users)) {
    return payload.users.map(normalizeUser);
  }

  return [];
};

export const formatEpochDate = (value) => {
  if (value === undefined || value === null || value === "") return "—";
  const numeric = Number(value);
  if (Number.isFinite(numeric) && numeric > 0) {
    const millis = numeric < 1e12 ? numeric * 1000 : numeric;
    const parsed = dayjs(millis);
    return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm") : "—";
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm") : "—";
};

export const matchesUserSearch = (user, filters = {}) => {
  const username = String(filters.username || "").trim().toLowerCase();
  const email = String(filters.email || "").trim().toLowerCase();
  const mobile = String(filters.mobile || "").trim().toLowerCase();

  if (username && !String(user.username || "").toLowerCase().includes(username)) {
    return false;
  }
  if (email && !String(user.email || "").toLowerCase().includes(email)) {
    return false;
  }
  if (mobile && !String(user.mobile || "").toLowerCase().includes(mobile)) {
    return false;
  }
  return true;
};
